import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs))
}

/**
 * מחזיר טקסט לתווית "כשר לפסח" – כולל שם הכשרות מ-kosherDetails אחרי ניטרול מילים גנריות.
 * דוגמה: "כשלפ מחפוד" → "כשר לפסח - מחפוד"
 */
export function getPassoverKosherLabel(kosherDetails) {
  const raw = (kosherDetails || "").trim();
  if (!raw) return "כשר לפסח";
  const genericPhrases = ["כשר לפסח", "כשלפ"];
  let rest = raw;
  for (const phrase of genericPhrases) {
    rest = rest.split(phrase).join("").trim();
  }
  rest = rest.replace(/\s+/g, " ").trim();
  if (!rest) return "כשר לפסח";
  return `כשר לפסח - ${rest}`;
} 